import { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { signIn } from 'next-auth/react';
import sectionStyles from '/components/Sections/Section.module.css';
import paneStyles from '/components/Panes/InfoPane.module.css';
import styles from './email.module.css';

export default function EmailAccount() {
  const router = useRouter();
  const resetToken = String(router.query.resetToken || '');
  const [mode, setMode] = useState(resetToken ? 'reset' : 'signin');
  const [form, setForm] = useState({ displayName: '', email: '', password: '', confirmPassword: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const update = (field) => (event) => setForm({ ...form, [field]: event.target.value });
  const submit = async (event) => {
    event.preventDefault(); setMessage(''); setError('');
    if ((mode === 'register' || mode === 'reset') && form.password !== form.confirmPassword) return setError('Passwords do not match.');
    if (mode === 'signin') {
      const result = await signIn('credentials', { email: form.email, password: form.password, redirect: false });
      if (result?.error) return setError('Email or password is incorrect, or the account is not activated.');
      return router.push('/Profile');
    }
    const endpoint = mode === 'register' ? '/api/auth/email/register' : mode === 'forgot' ? '/api/auth/email/request-reset' : '/api/auth/email/reset';
    const body = mode === 'reset' ? { token: resetToken, password: form.password } : form;
    const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const result = await response.json();
    if (!response.ok) return setError(result.error || 'Request failed.');
    setMessage(result.message);
    if (mode === 'reset') setMode('signin');
  };
  return <section className={`${sectionStyles.section} ${styles.page}`}>
    <div className={paneStyles.infoPane}><h1>ShuffleDB Account</h1><p>Google sign-in remains the recommended option. Email account delivery is being prepared.</p></div>
    <form className={styles.form} onSubmit={submit}>
      <nav><button type="button" className={mode === 'signin' ? styles.active : ''} onClick={() => setMode('signin')}>Sign In</button><button type="button" className={mode === 'register' ? styles.active : ''} onClick={() => setMode('register')}>Create Account</button></nav>
      {mode === 'register' && <label>Display Name<input required maxLength="80" value={form.displayName} onChange={update('displayName')} /></label>}
      {mode !== 'reset' && <label>Email<input required type="email" value={form.email} onChange={update('email')} /></label>}
      {mode !== 'forgot' && <label>Password<input required type="password" minLength="10" value={form.password} onChange={update('password')} /></label>}
      {(mode === 'register' || mode === 'reset') && <label>Confirm Password<input required type="password" minLength="10" value={form.confirmPassword} onChange={update('confirmPassword')} /></label>}
      <button type="submit">{mode === 'signin' ? 'Sign In' : mode === 'register' ? 'Create Email Account' : mode === 'forgot' ? 'Queue Password Reset' : 'Update Password'}</button>
      {mode === 'signin' && <button type="button" className={styles.textButton} onClick={() => setMode('forgot')}>Forgot password?</button>}
      {message && <p className={styles.success}>{message}</p>}{error && <p className={styles.error}>{error}</p>}
      {(mode === 'register' || mode === 'forgot') && <p className={styles.notice}>Outbound email is not configured yet. The request will be securely queued, but its activation or reset message will not be delivered until email service is enabled.</p>}
      <Link href="/">Back to ShuffleDB</Link>
    </form>
  </section>;
}
